import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() => ({
  root: {},
  cardTitle: {
    color: '#2E2D31',
    fontSize: '24px',
    lineHeight: '32px',
    marginBottom: '16px',
  },
  cardSubTitle: {
    color: '#2E2D31',
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: '26px',
    marginBottom: '8px',
  },
  cardText: {
    color: '#424140',
    fontSize: '18px',
    fontWeight: 500,
    lineHeight: '26px',
    marginBottom: '24px',
  },
}))
